var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row d-flex justify-content-center mt-5"},[_c('div',{staticClass:""},[_vm._v("\n        Received Data: \n        "+_vm._s(_vm.received_data)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }